import { useEffect, useState } from 'react';
import { ProjectSettings } from 'shared/types/projectSettings/ProjectSettings';
import { useProjSettings } from '@/frontastic/hooks/useProjectSettings/useProjectSettings';
import useSiteTranslation from '@/providers/i18n/hooks/useSiteTranslation';
import { PAGE_TEXTS_KEYS, SEARCH_BY_ORDER_QUEUES } from '../../../../../../../constants/constant';
import { CardDescription } from '../../../../ui/card';
import { Label } from '../../../../ui/label';
import { RadioGroup, RadioGroupItem } from '../../../../ui/radio-group';
const Index = ({ setSelectedSearchType, selectedSearchType, ORDER_SEARCH_TYPES }: any) => {
  const Texts = useSiteTranslation(PAGE_TEXTS_KEYS?.customerAndOrderSearch);
  const projectSettings: ProjectSettings = useProjSettings();

  const { allowedPermissionsForAgent } = projectSettings;

  const [isClientSide, setIsClientSide] = useState(false);

  useEffect(() => {
    setIsClientSide(true);
  }, []);
  return (
    <CardDescription>
      <RadioGroup
        defaultValue={selectedSearchType}
        onValueChange={(value) => {
          setSelectedSearchType(value);
        }}
        className="pointer flex"
      >
        <span className="flex items-center">
          <span className="mr-4 flex items-center">
            <RadioGroupItem
              value={ORDER_SEARCH_TYPES?.orderId}
              id={ORDER_SEARCH_TYPES?.orderId}
              className="mr-2 border-black"
            />
            <Label className="text-base font-normal" htmlFor={ORDER_SEARCH_TYPES?.orderId}>
              {Texts?.orderNumber}
            </Label>
          </span>
          <span className="mr-4 flex items-center">
            <RadioGroupItem
              value={ORDER_SEARCH_TYPES?.recipient}
              id={ORDER_SEARCH_TYPES?.recipient}
              className="mr-2 border-black"
            />
            <Label htmlFor={ORDER_SEARCH_TYPES?.recipient}>{Texts?.recipient}</Label>
          </span>
          {allowedPermissionsForAgent?.includes(SEARCH_BY_ORDER_QUEUES) && isClientSide && (
            <span className="mr-4 flex items-center">
              <RadioGroupItem
                value={ORDER_SEARCH_TYPES?.orderQueues}
                id={ORDER_SEARCH_TYPES?.orderQueues}
                className="mr-2 border-black"
              />
              <Label htmlFor={ORDER_SEARCH_TYPES?.orderQueues}>{Texts?.orderQueues}</Label>
            </span>
          )}
        </span>
      </RadioGroup>
    </CardDescription>
  );
};

export default Index;
